var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2795 23.0738C29.407 23.0738 30.3211 22.1347 30.3211 20.9762C30.3211 19.8177 29.407 18.8785 28.2795 18.8785C27.152 18.8785 26.2379 19.8177 26.2379 20.9762C26.2379 22.1347 27.152 23.0738 28.2795 23.0738Z",
    fill: "#121E28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5768 36.8259C17.4142 36.8259 18.9038 35.2955 18.9038 33.4075C18.9038 31.5196 17.4142 29.9891 15.5768 29.9891C13.7393 29.9891 12.2497 31.5196 12.2497 33.4075C12.2497 35.2955 13.7393 36.8259 15.5768 36.8259Z",
    fill: "#121E28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.327 23.8522C5.16447 23.8522 6.65403 22.3217 6.65403 20.4338C6.65403 18.5458 5.16447 17.0154 3.327 17.0154C1.48953 17.0154 -3.05176e-05 18.5458 -3.05176e-05 20.4338C-3.05176e-05 22.3217 1.48953 23.8522 3.327 23.8522Z",
    fill: "#121E28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4253 9.78952C16.5946 9.78952 17.5425 8.81559 17.5425 7.61418C17.5425 6.41278 16.5946 5.43884 15.4253 5.43884C14.256 5.43884 13.3081 6.41278 13.3081 7.61418C13.3081 8.81559 14.256 9.78952 15.4253 9.78952Z",
    fill: "#121E28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6506 13.2844C25.6946 13.2844 26.5409 12.4149 26.5409 11.3422C26.5409 10.2695 25.6946 9.3999 24.6506 9.3999C23.6066 9.3999 22.7602 10.2695 22.7602 11.3422C22.7602 12.4149 23.6066 13.2844 24.6506 13.2844Z",
    fill: "#121E28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42676 14.6065C7.93014 14.6065 9.14887 13.3544 9.14887 11.8097C9.14887 10.265 7.93014 9.01282 6.42676 9.01282C4.92337 9.01282 3.70464 10.265 3.70464 11.8097C3.70464 13.3544 4.92337 14.6065 6.42676 14.6065Z",
    fill: "#121E28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80544 33.2523C8.76819 33.2523 10.3593 31.6174 10.3593 29.6008C10.3593 27.5842 8.76819 25.9493 6.80544 25.9493C4.84269 25.9493 3.25156 27.5842 3.25156 29.6008C3.25156 31.6174 4.84269 33.2523 6.80544 33.2523Z",
    fill: "#121E28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1205 32.9407C25.6239 32.9407 26.8426 31.6885 26.8426 30.1438C26.8426 28.5991 25.6239 27.3469 24.1205 27.3469C22.6171 27.3469 21.3984 28.5991 21.3984 30.1438C21.3984 31.6885 22.6171 32.9407 24.1205 32.9407Z",
    fill: "#121E28"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2948 6.99216L39.9999 5.51604L36.3704 4.11761L34.8581 0L33.4215 4.03992L29.4895 5.51604L33.4971 7.06985L34.8581 10.8767L36.2948 6.99216Z",
    fill: "#E75300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ecd74ec6cfebf6b761fa894fdc6ef684.svg";
export { ForwardRef as ReactComponent };